import React, { useEffect } from 'react';
import App from '../App';
import { useAuth } from '../context/AuthContext';
import { TramiteProvider } from '../context/TramiteContext';
import { isESaveOnly, openESave } from '../services/applicationAccess';
import ESaveApp from './ESaveApp';
import Login from './Login';
import SessionStatus from './SessionStatus';
import AgencySupervisor from './backoffice/AgencySupervisor';

export default function PrivateApplication() {
    const { token, agentInfo, loading, sessionError, retrySession, login, logout } = useAuth();
    const esavePath = /^\/esave\/?$/.test(window.location.pathname);
    const agencyScope = agentInfo?.permissions?.agency_scope || agentInfo?.permissions?.capabilities?.includes('agency_supervisor');
    const redirect = !loading && !sessionError && token && agentInfo
        && !agencyScope && isESaveOnly(agentInfo.permissions) && !esavePath;

    useEffect(() => {
        if (redirect) openESave();
    }, [redirect]);

    if (loading || sessionError) return <SessionStatus loading={loading} error={sessionError} onRetry={retrySession} onLogout={logout} />;
    if (!token) return <Login prePasswordSession={process.env.REACT_APP_AGENCY_PREVIEW === '1'} onLoginSuccess={login} returnTo={esavePath ? window.location.pathname + window.location.search : null} />;
    if (agencyScope) return <AgencySupervisor />;
    if (redirect) return <p role="status">Abriendo ESave…</p>;
    return esavePath ? <ESaveApp /> : <TramiteProvider><App /></TramiteProvider>;
}
